import { CSSObject } from '@chakra-ui/react';

export const Wrapper: CSSObject = {
  h: ['50px', null, '80px'],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: 'body',
};

export const TextItem: CSSObject = {
  color: 'gamma.200',
  textAlign: 'center',
  fontSize: 'sm',
  fontStyle: 'normal',
  fontWeight: 'normal',
  textShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
};

export const LinkItem: CSSObject = {
  color: 'gamma.600',
  fontWeight: 'bold',
  textShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
};
